import React, { useState, useEffect } from "react";
import "./index.scss";
import content from "../../content/japanese";
import Navigation from "../../components/navigation";
import { Link } from "react-router-dom";

const getRandomNumber = (max) => Math.floor(Math.random() * max);
const items = ["jp", "en"];

const System = ({ type }) => {
  const [active, setActive] = useState({});
  const [clueIsVisible, setClueVisibility] = useState(false);
  const [answerIsVisible, setAnswerVisibility] = useState(false);
  const [language, setLanguage] = useState({ active: "jp", inactive: "en" });

  useEffect(() => {
    generate();
  }, []);

  const reset = () => {
    setClueVisibility(false);
    setAnswerVisibility(false);
  };

  const get = () => {
    const array = content[type] || [];
    const index = getRandomNumber(array.length);

    return array[index] || {};
  };

  const generate = () => {
    reset();

    const next = get();
    setActive(next);
  };

  const handleClueVisibility = () => {
    setClueVisibility(!clueIsVisible);
  };

  const handleSetLanguage = (nextLanguage) => {
    if (nextLanguage === language.active) return;

    const prevActive = language.active;

    setLanguage({ active: nextLanguage, inactive: prevActive });
  };

  const next = () => {
    if (!answerIsVisible) return setAnswerVisibility(true);

    generate();
  };

  return (
    <div className={`system${answerIsVisible ? " answer-visible" : ""}`}>
      <Navigation theme="light" subtext={type} />
      <p className={`active ${language.active}`}>{active[language.active]}</p>
      <div className="answer-divider"></div>
      <p className={`inactive ${language.active}`}>
        <span>{active[language.inactive]}</span>
      </p>
      <div className="options-corner">
        <div className="switcher">
          {items.map((item = {}, i) => (
            <div
              className={`switcher-item${
                language.active === item ? " switcher-item-active" : ""
              }`}
              key={`item_${i}`}
              onClick={() => handleSetLanguage(item)}
            >
              {item.toUpperCase()}
            </div>
          ))}
        </div>
        <div
          onClick={handleClueVisibility}
          className={`info${clueIsVisible ? " open" : ""}`}
        >
          <span className="info-icon">?</span>
          {clueIsVisible && (
            <div className="info-popup">
              <span className="info-dot"></span>
              <span>{active.clue}</span>
            </div>
          )}
        </div>
        <Link to="/japanese">
          <div onClick={handleClueVisibility} className="info close-button" />
        </Link>
      </div>
      <div className="options-side">
        <div onClick={next} className="info next-button" />
        <div onClick={generate} className="info skip-button">
          <div className="info-icon" />
        </div>
      </div>
    </div>
  );
};

export default System;
